(() => {
  'use strict';
  if (window.TecHubWishlist) return;

  const configNode = document.getElementById('techub-wishlist-config');
  const config = configNode ? configNode.dataset : {};
  const customerId = String(config.customerId || '').trim();
  const guestKey = 'techub:wishlist:v1:guest';
  const storageKey = customerId ? `techub:wishlist:v1:customer:${customerId}` : guestKey;
  const rootPrefix = String(config.shopRoot || '/');
  const memoryStore = { value: [] };
  const pageRoot = document.querySelector('[data-techub-wishlist-page]');
  const isArabic = String(config.locale || document.documentElement.lang || '').toLowerCase().startsWith('ar');
  const text = (key, fallback) => config[key] || fallback;

  const safeParse = (value) => {
    try { const parsed = JSON.parse(value || '[]'); return Array.isArray(parsed) ? parsed : []; }
    catch (_) { return []; }
  };
  const normalize = (item) => ({
    productId: String(item.productId || ''),
    variantId: String(item.variantId || ''),
    title: String(item.title || ''),
    url: String(item.url || ''),
    jsonUrl: String(item.jsonUrl || ''),
    image: String(item.image || ''),
    vendor: String(item.vendor || ''),
    variantTitle: String(item.variantTitle || ''),
    price: Number(item.price || 0),
    compareAt: Number(item.compareAt || 0),
    available: item.available !== false,
    addedAt: Number(item.addedAt || Date.now())
  });
  const uniqueItems = (items) => {
    const map = new Map();
    items.map(normalize).filter((item) => item.productId && item.variantId).forEach((item) => {
      map.set(`${item.productId}:${item.variantId}`, item);
    });
    return Array.from(map.values()).slice(-150);
  };
  const readKey = (key) => {
    try { return safeParse(localStorage.getItem(key)); }
    catch (_) { return memoryStore.value; }
  };
  const writeKey = (key, items) => {
    const clean = uniqueItems(items);
    try { localStorage.setItem(key, JSON.stringify(clean)); }
    catch (_) { memoryStore.value = clean; document.dispatchEvent(new CustomEvent('techub:wishlist:error')); }
    return clean;
  };
  let items = readKey(storageKey);
  if (customerId) {
    const guestItems = readKey(guestKey);
    if (guestItems.length) {
      items = writeKey(storageKey, [...items, ...guestItems]);
      try { localStorage.removeItem(guestKey); } catch (_) {}
    }
  }

  const keyFor = (productId, variantId) => `${String(productId)}:${String(variantId)}`;
  const isSaved = (productId, variantId) => items.some((item) => keyFor(item.productId, item.variantId) === keyFor(productId, variantId));
  const save = () => {
    items = writeKey(storageKey, items);
    document.dispatchEvent(new CustomEvent('techub:wishlist:updated', { detail: { items: [...items], count: items.length } }));
  };
  const remove = (productId, variantId) => {
    items = items.filter((item) => keyFor(item.productId, item.variantId) !== keyFor(productId, variantId));
    save();
  };
  const toggle = (details) => {
    if (!details.productId || !details.variantId) return;
    if (isSaved(details.productId, details.variantId)) {
      remove(details.productId, details.variantId);
      announce(text('textRemoved', 'Removed from Wishlist'));
      return;
    }
    items.push(normalize({ ...details, addedAt: Date.now() }));
    save();
    announce(text('textAdded', 'Added to Wishlist'));
  };
  const announce = (message) => {
    let node = document.getElementById('techub-wishlist-live');
    if (!node) {
      node = document.createElement('div');
      node.id = 'techub-wishlist-live';
      node.className = 'visually-hidden';
      node.setAttribute('role', 'status');
      node.setAttribute('aria-live', 'polite');
      document.body.appendChild(node);
    }
    node.textContent = message;
  };
  const getVariantFromStudio = (root, id) => {
    const node = root?.querySelector('[data-tp-variants-json]');
    if (!node) return null;
    try { return JSON.parse(node.textContent || '[]').find((variant) => String(variant.id) === String(id)) || null; }
    catch (_) { return null; }
  };
  const extractVariantFromUrl = (card) => {
    const anchors = card ? card.querySelectorAll('a[href*="/products/"]') : [];
    for (const anchor of anchors) {
      try {
        const url = new URL(anchor.getAttribute('href') || anchor.href, window.location.origin);
        const id = url.searchParams.get('variant') || url.searchParams.get('variant_id') || url.searchParams.get('variantId');
        if (id) return id;
      } catch (_) {}
    }
    return '';
  };
  const getDetails = (button) => {
    const studio = button.closest('[data-tp-product-studio]');
    const tmcCard = button.closest('[data-tmc-card]');
    const productCard = button.closest('product-card');
    const container = studio || tmcCard || productCard || button.closest('.th-shelf-card') || button.parentElement;
    const productId = String(button.dataset.wishlistProductId || tmcCard?.dataset.productId || productCard?.dataset.productId || container?.dataset.productId || '');
    let variantId = String(button.dataset.wishlistVariantId || '');
    if (studio) variantId = String(studio.querySelector('[data-tp-variant-id]')?.value || variantId);
    if (tmcCard) variantId = String(tmcCard.dataset.variantId || tmcCard.dataset.tmcActiveVariantId || variantId);
    const formVariant = container?.querySelector('form input[name="id"], input[name="id"][data-techub-variant-id]')?.value;
    if (!studio && !tmcCard && formVariant) variantId = String(formVariant);
    if (!studio && !tmcCard) variantId = extractVariantFromUrl(container) || variantId;

    let title = button.dataset.wishlistTitle || tmcCard?.querySelector('.tmc__product-title')?.textContent?.trim() || productCard?.querySelector('.product-card__link')?.getAttribute('aria-label') || container?.dataset.title || '';
    let url = button.dataset.wishlistUrl || tmcCard?.querySelector('a[href*="/products/"]')?.getAttribute('href') || productCard?.querySelector('a[href*="/products/"]')?.getAttribute('href') || container?.dataset.url || '';
    let image = button.dataset.wishlistImage || tmcCard?.querySelector('.tmc__image:not(.tmc__image--secondary)')?.currentSrc || productCard?.querySelector('img')?.currentSrc || container?.dataset.image || '';
    let vendor = button.dataset.wishlistVendor || '';
    let variantTitle = button.dataset.wishlistVariantTitle || '';
    let price = Number(button.dataset.wishlistPrice || 0);
    let compareAt = Number(button.dataset.wishlistCompare || 0);
    let available = button.dataset.wishlistAvailable !== 'false';

    if (tmcCard) {
      const selectedId = String(variantId);
      try {
        const variantsRaw = productCard?.dataset.techubVariants;
        const variant = variantsRaw ? JSON.parse(variantsRaw).find((entry) => String(entry.id) === selectedId) : null;
        if (variant) {
          variantTitle = Array.isArray(variant.options) ? variant.options.join(' / ') : variantTitle;
          available = variant.available !== false;
          image = variant.image || image;
          price = Number(variant.price_cents ?? price);
          compareAt = Number(variant.compare_at_price_cents ?? compareAt);
        }
      } catch (_) {}
      const color = tmcCard.dataset.tmcColorValue;
      if (color) variantTitle = color;
      const href = tmcCard.querySelector('a[href*="/products/"]')?.getAttribute('href');
      if (href) url = href;
    }
    if (studio) {
      const selected = getVariantFromStudio(studio, variantId);
      const mainImage = studio.querySelector('[data-tp-main-image]');
      if (selected) {
        variantTitle = Array.isArray(selected.options) ? selected.options.join(' / ') : variantTitle;
        image = selected.image_url || image;
        price = Number(selected.price_cents ?? price);
        compareAt = Number(selected.compare_at_price_cents ?? compareAt);
        available = selected.available !== false;
      }
      if (mainImage?.currentSrc) image = mainImage.currentSrc;
    }
    const pageLink = url ? new URL(url, window.location.origin) : null;
    const jsonUrl = button.dataset.wishlistJsonUrl || (pageLink ? `${pageLink.pathname.replace(/\/$/, '')}.js` : '');
    return { productId, variantId, title, url: url || '#', jsonUrl, image, vendor, variantTitle, price, compareAt, available };
  };

  const updateUI = () => {
    document.querySelectorAll('[data-techub-wishlist-trigger]').forEach((button) => {
      const details = getDetails(button);
      const active = isSaved(details.productId, details.variantId);
      button.setAttribute('aria-pressed', String(active));
      const label = active ? text('textRemove', 'Remove from Wishlist') : text('textAdd', 'Add to Wishlist');
      button.setAttribute('aria-label', label);
      button.title = label;
      const labelNode = button.querySelector('[data-wishlist-button-label]');
      if (labelNode) labelNode.textContent = label;
    });
    document.querySelectorAll('[data-techub-wishlist-count]').forEach((node) => {
      node.textContent = String(items.length);
      node.hidden = items.length === 0;
      node.setAttribute('aria-label', String(items.length));
    });
    if (pageRoot) renderPage();
  };

  const make = (tag, className, content) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (content !== undefined) node.textContent = content;
    return node;
  };
  const formatMoney = (cents) => {
    const amount = Number(cents || 0) / 100;
    const currency = config.currency || 'EGP';
    const locale = isArabic ? 'ar-EG' : (config.locale || 'en-EG');
    try { return new Intl.NumberFormat(locale, { style: 'currency', currency, maximumFractionDigits: 2 }).format(amount); }
    catch (_) { return `${currency} ${amount.toFixed(2)}`; }
  };
  const refreshProductData = async (item) => {
    if (!item.jsonUrl) return item;
    try {
      const response = await fetch(item.jsonUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) return item;
      const product = await response.json();
      const variant = (product.variants || []).find((entry) => String(entry.id) === String(item.variantId));
      if (!variant) return { ...item, available: false };
      return {
        ...item,
        title: product.title || item.title,
        url: product.url || item.url,
        image: variant.featured_image?.src || product.featured_image || item.image,
        variantTitle: variant.title && variant.title !== 'Default Title' ? variant.title : '',
        price: Number(variant.price || 0),
        compareAt: Number(variant.compare_at_price || 0),
        available: Boolean(variant.available)
      };
    } catch (_) { return item; }
  };
  let renderToken = 0;
  const renderPage = async () => {
    if (!pageRoot) return;
    const grid = pageRoot.querySelector('[data-wishlist-grid]');
    const empty = pageRoot.querySelector('[data-wishlist-empty]');
    const clearButton = pageRoot.querySelector('[data-wishlist-clear]');
    const count = pageRoot.querySelector('[data-wishlist-page-count]');
    if (!grid || !empty) return;
    const currentToken = ++renderToken;
    grid.replaceChildren();
    const saved = [...items];
    if (count) count.textContent = `${saved.length} ${text('textItems', 'saved items')}`;
    if (clearButton) clearButton.hidden = saved.length === 0;
    empty.hidden = saved.length !== 0;
    if (!saved.length) return;

    const hydrated = await Promise.all(saved.map(refreshProductData));
    if (currentToken !== renderToken) return;
    items = writeKey(storageKey, hydrated);
    hydrated.forEach((item) => {
      const article = make('article', 'techub-wishlist-card');
      const media = make('a', 'techub-wishlist-card__media');
      media.href = item.url || '#';
      if (item.image) {
        const image = make('img'); image.src = item.image; image.alt = item.title; image.loading = 'lazy'; image.decoding = 'async'; image.width = 640; image.height = 640; media.appendChild(image);
      }
      article.appendChild(media);
      const body = make('div', 'techub-wishlist-card__body');
      const title = make('a', 'techub-wishlist-card__title', item.title || 'TecHub product'); title.href = item.url || '#'; body.appendChild(title);
      if (item.variantTitle) body.appendChild(make('p', 'techub-wishlist-card__variant', `${text('textVariant', 'Variant')}: ${item.variantTitle}`));
      const priceRow = make('div', 'techub-wishlist-card__price-row');
      priceRow.appendChild(make('span', 'techub-wishlist-card__price', formatMoney(item.price)));
      if (item.compareAt > item.price) priceRow.appendChild(make('del', 'techub-wishlist-card__compare', formatMoney(item.compareAt)));
      body.appendChild(priceRow);
      const actions = make('div', 'techub-wishlist-card__actions');
      const addForm = make('form'); addForm.method = 'post'; addForm.action = config.cartAddUrl || `${rootPrefix}cart/add`;
      const variantInput = make('input'); variantInput.type = 'hidden'; variantInput.name = 'id'; variantInput.value = item.variantId; addForm.appendChild(variantInput);
      const qtyInput = make('input'); qtyInput.type = 'hidden'; qtyInput.name = 'quantity'; qtyInput.value = '1'; addForm.appendChild(qtyInput);
      const addButton = make('button', 'techub-wishlist-card__add', item.available ? text('textAddToCart', 'Add to cart') : text('textSoldOut', 'Sold out'));
      addButton.type = 'submit'; addButton.disabled = !item.available; addForm.appendChild(addButton);
      actions.appendChild(addForm);
      const removeButton = make('button', 'techub-wishlist-card__remove'); removeButton.type = 'button'; removeButton.setAttribute('aria-label', text('textRemoveItem', 'Remove'));
      removeButton.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h18M8 6V4h8v2m3 0-.8 14H5.8L5 6m4 4v6m6-6v6"/></svg>';
      removeButton.addEventListener('click', () => remove(item.productId, item.variantId));
      actions.appendChild(removeButton);
      body.appendChild(actions);
      article.appendChild(body);
      grid.appendChild(article);
    });
    document.dispatchEvent(new CustomEvent('techub:wishlist:page-rendered'));
  };

  const ensureShelfButton = (card) => {
    if (!card || card.querySelector('[data-techub-wishlist-trigger]')) return;
    const productId = card.dataset.productId;
    const url = card.dataset.url || card.querySelector('a[href*="/products/"]')?.getAttribute('href') || '';
    if (!productId || !url) return;
    const imageNode = card.querySelector('img');
    const button = document.createElement('button');
    button.type = 'button'; button.className = 'techub-wishlist-trigger';
    button.dataset.techubWishlistTrigger = '';
    button.dataset.wishlistProductId = String(productId);
    button.dataset.wishlistVariantId = String(card.dataset.variantId || '');
    button.dataset.wishlistTitle = card.dataset.title || card.querySelector('.th-shelf-card__title')?.textContent?.trim() || '';
    button.dataset.wishlistUrl = url;
    button.dataset.wishlistJsonUrl = `${new URL(url, window.location.origin).pathname.replace(/\/$/, '')}.js`;
    button.dataset.wishlistImage = card.dataset.image || imageNode?.src || '';
    button.setAttribute('aria-pressed', 'false');
    button.setAttribute('aria-label', text('textAdd', 'Add to Wishlist'));
    button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78Z"/></svg><span class="visually-hidden" data-wishlist-button-label></span>';
    card.appendChild(button);
  };
  const mountDynamicCards = (scope = document) => {
    scope.querySelectorAll?.('.th-shelf-card').forEach(ensureShelfButton);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-techub-wishlist-trigger]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    const details = getDetails(button);
    if (!details.productId || !details.variantId) {
      announce(text('textError', 'Could not save the wishlist on this device.'));
      return;
    }
    toggle(details);
  }, true);

  document.addEventListener('click', (event) => {
    const clear = event.target.closest('[data-wishlist-clear]');
    if (!clear) return;
    event.preventDefault();
    items = [];
    save();
  });
  document.addEventListener('techub:wishlist:error', () => announce(text('textError', 'Could not save the wishlist on this device.')));
  document.addEventListener('techub:wishlist:updated', updateUI);
  document.addEventListener('input', (event) => {
    if (event.target.matches('[data-tp-variant-id], product-card input[name="id"]')) updateUI();
  });
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-tp-variant-id], product-card input[name="id"]')) updateUI();
  });
  window.addEventListener('storage', (event) => {
    if (event.key === storageKey) { items = readKey(storageKey); updateUI(); }
  });

  window.TecHubWishlist = {
    getItems: () => [...items],
    isSaved,
    add: (details) => { if (!isSaved(details.productId, details.variantId)) { items.push(normalize(details)); save(); } },
    remove,
    clear: () => { items = []; save(); },
    refresh: updateUI
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { mountDynamicCards(); updateUI(); }, { once: true });
  else { mountDynamicCards(); updateUI(); }
  const observer = new MutationObserver((mutations) => {
    let shouldUpdate = false;
    for (const mutation of mutations) {
      if (mutation.type === 'attributes') {
        shouldUpdate = true;
        continue;
      }
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches?.('.th-shelf-card')) { ensureShelfButton(node); shouldUpdate = true; }
        mountDynamicCards(node);
        if (node.matches?.('[data-techub-wishlist-trigger], product-card[data-product-id], [data-tmc-card]') || node.querySelector?.('[data-techub-wishlist-trigger], product-card[data-product-id], [data-tmc-card]')) shouldUpdate = true;
      });
    }
    if (shouldUpdate) updateUI();
  });
  if (document.body) observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-variant-id', 'data-tmc-active-variant-id'] });
})();
